import { Component, OnInit } from '@angular/core';
import { TransaccionesService } from './services/transacciones.service';

import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [DatePipe]
})
export class AppComponent implements OnInit {
  title = 'monitoreo';
  url = 'https://services.circulodecredito.com.mx/v1/monitoreo/transacciones/incidencias/rango';

  apisName= [];
  fecha = [];

  toDay= new Date();
  myDate = new Date();
  fechaInicio: string;
  fechaFin: string;
  resta;
  suma;


  siguiente;

  validaFecha;
  validaFecha1;
  validaFecha2;
  day;
  month;
  year;
  

  constructor(
    private transaccionesService: TransaccionesService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.getFecha(6);
  }


  getFecha(item) {
    this.fecha = []
    this.resta = this.myDate.setDate(this.myDate.getDate()-item);
    this.fechaInicio = this.datePipe.transform(this.resta, 'dd-MM-yyyy');
    this.fecha.push(this.fechaInicio);
    
    

    for (let i = 5; i >= 0; i--) {
      this.suma = this.myDate.setDate(this.myDate.getDate()+1);
      this.fechaFin = this.datePipe.transform(this.suma, 'dd-MM-yyyy');
      this.fecha.push(this.fechaFin);
    }

    // no borrar
    this.transaccionesService.getJson( [this.url, this.fechaInicio, this.fechaFin] ).subscribe((data : any) =>  {
      this.apisName = data;
      // console.log(this.apisName);
    } );


    this.validaFecha1 = this.datePipe.transform(this.toDay, 'dd-MM-yyyy');
    this.validaFecha2 = this.fecha[6];

    if ( this.validaFecha1 === this.validaFecha2 ) {
      this.siguiente = true;
    } else {
      this.siguiente = false;
    }

  }



  lastDate(day) {
    this.getFecha(day+6);
  }
  
  nextDate(day) {
    this.getFecha(day);
  }


  hideModal():void {
    document.getElementById('close-modal').click();
  }


}
